<script setup>

import {computed} from "vue"

const props = defineProps({
  value: Array,
  active: Object,
  sort: String
})

const sortedItems = computed(() => {
  const norm = i => ({
    price: i.sale_price != null
        ? (typeof i.sale_price === 'number' ? i.sale_price : parseFloat(i.sale_price))
        : (i.salePrice != null
            ? (typeof i.salePrice === 'number' ? i.salePrice : parseFloat(i.salePrice))
            : null),
    date: new Date(
        i.date_sold ||
        i.itemCreationDate ||
        i.dateSold ||
        i.created ||
        0
    ).getTime(),
  })

  return [...props.value].sort((a, b) => {
    const A = norm(a), B = norm(b)

    switch (props.sort) {
      case 'price_asc':  return (A.price ?? Infinity)   - (B.price ?? Infinity)
      case 'price_desc': return (B.price ?? -Infinity)  - (A.price ?? -Infinity)
      case 'date_asc':   return A.date - B.date
      case 'date_desc':  return B.date - A.date
      default:           return 0
    }
  })
})

</script>

<template>
  <div>
    <b-list-group v-if="value">
      <b-list-group-item :active="active?.item_id === product.item_id" v-for="(product, index) in sortedItems" :key="index"
                         target="_blank" :href="product.link">
        <div class="mb-1">{{ product.title }}</div>
        <div class="d-flex align-items-center">
          <b-img v-if="product.thumbnail" thumbnail fluid :src="product.thumbnail" class="thumbnail mr-3"></b-img>
          <b-img v-if="product.image_url" thumbnail fluid :src="product.image_url" class="thumbnail mr-3"></b-img>
          <div class="flex-grow-1">
            <div v-if="product.date_sold">Sold on {{ product.date_sold | dateonly}}</div>
            <div class="d-flex">
              <div class="mt-2 mb-0 h6 flex-fill">{{ product.condition }}</div>
              <div class="mt-2 mb-0 h6 text-right">{{ product.sale_price | money }}</div>
            </div>
            <div class="text-right"><small v-if="product.buying_format">{{ product.buying_format }}</small></div>
          </div>
        </div>
        <div class="text-muted mt-1" v-if="product.reason">{{ product.reason}}</div>
      </b-list-group-item>
    </b-list-group>
  </div>

</template>

<style scoped>
/* Optional: Custom styles for the thumbnail or text if needed */
.thumbnail {
  width: 64px; /* Adjust thumbnail size as desired */
  height: 64px;
  object-fit: cover; /* Ensures image fills the space without distortion */
}
</style>
